import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Scale, Handshake, Zap, CreditCard } from "lucide-react";

const ICONS = [Scale, Handshake, Zap, CreditCard];

export default function WhyUs() {
  const { t } = useLang();
  const pillars = [1, 2, 3, 4].map((n) => ({ t: t(`why.${n}t`), d: t(`why.${n}d`) }));
  return (
    <section id="perche-noi" className="py-20 lg:py-28 bg-white" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#00AEEF]">{t("why.kicker")}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#003087] mt-3">{t("why.title")}</h2>
          <p className="mt-4 text-base text-[#64748B]">{t("why.sub")}</p>
        </motion.div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {pillars.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div key={i}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.55, delay: i * 0.1 }}
                className="card rounded-3xl p-7" data-testid={`why-pillar-${i + 1}`}>
                <div className="w-12 h-12 rounded-2xl bg-[#003087] flex items-center justify-center">
                  <Icon size={20} className="text-[#00AEEF]" />
                </div>
                <h3 className="text-lg font-bold text-[#003087] mt-5">{p.t}</h3>
                <p className="text-sm text-[#1A1A1A] leading-relaxed mt-3">{p.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
